import { AxiosResponse, AxiosError } from "axios";

import { ALLOWANCE_API_ENDPOINTS } from "@/features/allowance/api/endpointsAllowance";
import {
  newAllowanceModelToLegacyModel,
  legacyAllowanceItemToNewItem,
} from "@/features/allowance/helpers/formatLegacyAllowanceModels";
import { AllowanceLegacyModel } from "@/features/allowance/types/allowanceLegacyModel";
import { AllowanceBaseModel } from "@/features/allowance/types/allowanceModels";
import apiRequests from "@/shared/config/axiosConfig";

export default async function addAllowance(
  allowance: AllowanceBaseModel
): Promise<AllowanceBaseModel> {
  try {
    const url = ALLOWANCE_API_ENDPOINTS.CREATE_ALLOWANCE;
    const legacyAllowance = newAllowanceModelToLegacyModel(allowance);
    const response: AxiosResponse<AllowanceLegacyModel> = await apiRequests.post(
      url,
      legacyAllowance
    );
    const { data: legacyData, status } = response;

    if (status >= 200 && status < 300) {
      const newData = legacyAllowanceItemToNewItem(legacyData);
      return newData;
    }

    throw new Error(`Unknown error occurred with status code ${response.status}`);
  } catch (e) {
    // @todo Handle Error Below
    const error = e as AxiosError;
    switch (error.response?.status) {
      case 400:
        throw new Error("400: Bad Request");
      case 401:
        throw new Error("401: Unauthorized");
      case 404:
        throw new Error("404: Not Found");
      default:
        throw new Error(
          `Unknown error occurred with status code ${error.response?.status}`
        );
    }
  }
}
